/*
 * @Author: 317473294@qq.com
 * @Date: 2022-03-04 16:23:29
 * @LastEditTime: 2025-06-27 21:40:06
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /yi_xue_frontEnd/src/main.js
 */

import Vue from 'vue'

import store from './store'

import vueDraggableResizable from 'vue-draggable-resizable-gorkys'
import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'

import ECharts from 'vue-echarts'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import { color } from 'echarts';
import { formatDate } from "@/utils/time.js";
// 将formatDate添加到Vue的原型上  
Vue.prototype.$formatDate = formatDate; 
import 'font-awesome/css/font-awesome.min.css';
import less from 'less'
Vue.use(less)

import mockdata from "@/mock/index.js"
import Video from "video.js"
import "video.js/dist/video-js.css"
Vue.prototype.$video=Video
// 覆盖console.log
console.log = () => {}
//全局按钮权限
import permission from '@/utils/priButton.js'

//导入封装的公共组件
import {zdyMessage} from '@/components/common/message.js'
//通用弹框消息插件
Vue.prototype.$zdyMessage=zdyMessage
//将数组封装成树形结构
import {tools} from "@/utils/tools.js"
Vue.prototype.$tools=tools

//全局函数
// import {currentRouterToMeta} from "@/utils/golobal.js"
// Vue.prototype.$currentRouterToMeta=currentRouterToMeta

// import ECharts from 'vue-echarts/components/ECharts.vue'

Vue.config.productionTip = false
Vue.component('vueDraggableResizable',vueDraggableResizable)
Vue.component('v-chart', ECharts) 

Vue.use(ElementUI);

Vue.prototype.$imgUrl="https://jszsbapi.learnpathway.com"//"https://jszsbapi.learnpathway.com"///"http://127.0.0.1:7001"
// Vue.prototype.$imgUrl="http://127.0.0.1:7001"
Vue.prototype.$bus=new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  data:function(){
    return{
      $bus:""
    }
  },
  directives:{
    permission
},
})
/**
 * @description: 自适应，设置body.style.fontSize
 * @param {*}
 * @return {*}
 */
function onResize() {
  let zdyWidth=1920;
  let bodyWidth = document.body.getBoundingClientRect().width;
  // Vue.prototype.$height=document.body.getBoundingClientRect().height;
  // console.log("宽度是",Vue.prototype.$height)
  let html = document.getElementsByTagName('html')[0];
   let sizerem=parseInt(bodyWidth/(1920/100))
  html.style.fontSize=sizerem+ 'px';
}
window.addEventListener('resize', onResize);
// onResize();




// WEBPACK FOOTER //
// ./src/main.js